import abi from "./Transactions.json";

export const contractABI = abi.abi;
export const contractAddress = "0x3A85794641966D632F55857bD880BC3F9eF0521C";
